import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../../ButtonLink";
import { paginationCustomerPackageOfferSubscriptionLog } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";

const PackagePaymentReceipt = () => {
  const { storeData, brandProfileData, userProfileData } = getUserData();

  let store = storeData;
  let brand = brandProfileData;
  const userProfile = userProfileData;

  const { storeLocalData } = getStoreLocalData();

  const location = useLocation();
  const { storeCustomerId, paymentDetails, customerData } =
    location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const data = {
    storeName: store.storeName,
    brandName: brand.name,
    fullAddress: store.address.fullAddress,
    mobileNumber: store.mobileNo,
    email: store.email,
    customerName: [
      customerData?.brandCustomer?.firstName,
      customerData?.brandCustomer?.lastName,
    ]
      .filter(
        (name) =>
          name &&
          name !== "null" &&
          name !== "undefined"
      )
      .join(" "),
    customerMobile: customerData?.brandCustomer?.mobile,
    receivedBy: userProfile.firstName + " " + userProfile.lastName,
    paymentMode: paymentDetails.paymentMode?.replace(/_/g, " "),
    offerName: paymentDetails.brandPackageOffer?.name?.replace(/_/g, " "),
    category: paymentDetails.brandPackageOffer?.offerCategory?.name?.replace(
      /_/g,
      " "
    ),
    daysToConsume: paymentDetails.brandPackageOffer.validity,
    discount: paymentDetails.brandPackageOffer.value,
    serviceValue: paymentDetails.brandPackageOffer.serviceValue,
    packageValue: paymentDetails.brandPackageOffer.packageValue,
    subscriptionDate:
      new Date(paymentDetails.createdDate)?.getDate() +
      "-" +
      parseInt(new Date(paymentDetails.createdDate)?.getMonth() + 1) +
      "-" +
      new Date(paymentDetails.createdDate)?.getFullYear(),
    validFromDate:
      new Date(paymentDetails.validFrom)?.getDate() +
      "-" +
      parseInt(new Date(paymentDetails.validFrom)?.getMonth() + 1) +
      "-" +
      new Date(paymentDetails.validFrom)?.getFullYear(),
    validToDate:
      new Date(paymentDetails.validTo)?.getDate() +
      "-" +
      parseInt(new Date(paymentDetails.validTo)?.getMonth() + 1) +
      "-" +
      new Date(paymentDetails.validTo)?.getFullYear(),
  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

    const [customerPackageOfferSubscriptionLogData, setCustomerPackageOfferSubscriptionLogData] =
          useState("");

const [customerPackageOfferSubscriptionLogAmountData, setCustomerPackageOfferSubscriptionLogAmountData] =
    useState("");          
      
        const fetchCustomerPackageOfferSubscriptionLogList = (data, page = 0) => {
          paginationCustomerPackageOfferSubscriptionLog(brand?.id, store.id, paymentDetails?.id, {
            ...data,
            limit: 1,
            offset: page * 1, // Ensure offset is correctly applied
          })
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                  setCustomerPackageOfferSubscriptionLogData(Res[0]?.paymentInfo?.paymentMode);
                setCustomerPackageOfferSubscriptionLogAmountData(Res[0]?.paymentInfo?.amount);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        };

  useEffect(() => {
    if(!isConnected) 
      {
        connectToQZ();
      }

    const data = {
      // subscriberId: item.id,
      sortOrder: "desc",
    }
    fetchCustomerPackageOfferSubscriptionLogList(data, 0);
    fetchSelectedInvoicePrinter()
  }, [])
  
  const printInvoiceHTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const htmlContent = `
      <html>
        <body style="font-size: 12px; font-family: sans-serif;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;">Payment Receipt</span>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
            <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
            <p style="font-size: 12px; margin: 0;">${data.email}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Subscription Date:</strong></span>
              <span>${data.subscriptionDate}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Package Name:</strong></span>
              <span>${data.offerName}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span><strong>Service Value:</strong></span>
              <span>${data.serviceValue} + {storeLocalData?.taxType}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Valid From:</strong></span>
              <span>${data.validFromDate}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Valid To:</strong></span>
              <span>${data.validToDate}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Received Amount:</strong></span>
              <span>${storeLocalData?.currencySymbol + ' ' + customerPackageOfferSubscriptionLogAmountData}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Payment Mode:</strong></span>
              <span>${customerPackageOfferSubscriptionLogData}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Discount:</strong></span>
              <span>${data.discount + " %"}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Days To Consume:</strong></span>
              <span>${data.daysToConsume}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>CustomerName:</strong></span>
              <span>${data.customerName}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Mobile No.:</strong></span>
              <span>${data.customerMobile}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Received By:</strong></span>
              <span>${data.receivedBy}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/CustomerPackageOffer", {
                      state: {
                        customerData: customerData,
                        storeCustomerId: storeCustomerId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Payment Receipt
              </p>
            </div>
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={printInvoiceHTML}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="flex justify-content-center flex-column print-section">
          <p className="text-3xl font-medium text-center">Payment Receipt</p>
          <div className="flex justify-content-center align-items-center">
            <p className="w-7  border-dashed border-1 "></p>
          </div>
          <p className="text-xl font-medium text-center">{data.storeName}</p>
          <p className="text-lg font-normal text-center">{data.fullAddress}</p>
          <p className="text-lg font-normal text-center">{data.mobileNumber}</p>
          <p className="text-lg font-normal text-center">{data.email}</p>
          <div className="flex justify-content-center align-items-center">
            <p className="w-5  border-dashed border-1 "></p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Subscription Date:</p>
            <p className="text-lg font-normal text-right">
              {data.subscriptionDate}
            </p>
          </div>
          <div className="flex justify-content-center align-items-center">
            <p className="w-5  border-dashed border-1 "></p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Package Name:</p>
            <p className="text-lg font-normal text-right">{data.offerName}</p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Service Value:</p>
            <p className="text-lg font-normal text-right">
              {storeLocalData?.currencySymbol} {data.serviceValue} + {storeLocalData?.taxType}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Valid From:</p>
            <p className="text-lg font-normal text-right">
              {data.validFromDate}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Valid To.</p>
            <p className="text-lg font-normal text-right">{data.validToDate}</p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Received Amount:</p>
            <p className="text-lg font-normal text-right">
              {storeLocalData?.currencySymbol} {customerPackageOfferSubscriptionLogAmountData}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Payment Mode :</p>
            <p className="text-lg font-normal text-right">{customerPackageOfferSubscriptionLogData}</p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Discount:</p>
            <p className="text-lg font-normal text-right">{data.discount} %</p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Days To Consume :</p>
            <p className="text-lg font-normal text-right">
              {data.daysToConsume}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Received From :</p>
            <p className="text-lg font-normal text-right">
              {data.customerName}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Mobile No. :</p>
            <p className="text-lg font-normal text-right">
              {data.customerMobile}
            </p>
          </div>
          <div className="flex justify-content-between gap-5">
            <p className="text-lg font-normal text-left">Received By :</p>
            <p className="text-lg font-normal text-right">{data.receivedBy}</p>
          </div>
          <div className="flex justify-content-center align-items-center">
            <p className="w-7  border-dashed border-1 "></p>
          </div>
          <p className="text-3xl font-medium text-center">
            Powered By {data.brandName}
          </p>
        </div>

        <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 60,
            }}
          />
        </div>
      </div>
      {/* Menu component */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
            @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PackagePaymentReceipt;
